export default __webpack_public_path__ + "static/media/background-ppe2.cd390d15.jpg";